import { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { AdminUser, useAdmin } from "../hooks/useAdmin";

export function AdminLogin() {
  const { refresh } = useAdmin();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    const r = await api<AdminUser>("/api/auth/admin/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });

    if (!r.ok) {
      setError(
        r.status === 401
          ? "Credenciais inválidas."
          : `Erro (HTTP ${r.status}): ${JSON.stringify(r.body)}`
      );
      setSubmitting(false);
      return;
    }

    await refresh();
    navigate("/admin");
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>Admin · Entrar</h1>
        <p className="hint">
          Login separado do usuário comum. Use as credenciais configuradas em{" "}
          <code>ADMIN_EMAIL</code> / <code>ADMIN_PASSWORD</code>.
        </p>
        <form onSubmit={onSubmit}>
          <label>
            Email
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@exemplo.com"
              disabled={submitting}
              autoFocus
            />
          </label>
          <label>
            Senha
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={submitting}
            />
          </label>
          {error && <p className="error">{error}</p>}
          <button type="submit" disabled={submitting || !email || !password}>
            {submitting ? "Entrando..." : "Entrar como admin"}
          </button>
        </form>
      </div>
    </div>
  );
}
